import { render, staticRenderFns } from "./CorrectAndRevisedReports.vue?vue&type=template&id=4e3efeb3"
import script from "./CorrectAndRevisedReports.vue?vue&type=script&lang=js"
export * from "./CorrectAndRevisedReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports